export interface AnimeEpisode {
  id: number;
  title: string;
  episode: number;
}

export interface AnimeItem {
  id: number;
  title: string;
  slug: string;
  category: string;
  coverImage: string;
  rating: number;
  year: number;
  region: string;
  status: string;
  description: string;
  tags: string[];
  episodes: AnimeEpisode[];
  views: number;
  updateTime: string;
}

export const animeCategories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'riman', name: '日漫', icon: 'ri-japan-line' },
  { slug: 'guoman', name: '国漫', icon: 'ri-china-railway-line' },
  { slug: 'jingdian', name: '经典番剧', icon: 'ri-vip-crown-line' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line' },
];

export const animeList: AnimeItem[] = [
  {
    id: 1,
    title: '鬼灭之刃 柱训练篇',
    slug: 'guimie-zhi-ren-zhu-xunlian',
    category: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20style%20poster%2C%20Japanese%20warrior%20with%20sword%20against%20dark%20red%20sunset%20background%2C%20dynamic%20action%20pose%2C%20cinematic%20lighting%2C%20clean%20composition%2C%20manga%20art%20aesthetic&width=400&height=560&seq=anime-01&orientation=portrait',
    rating: 9.5,
    year: 2024,
    region: '日本',
    status: '更新中',
    description: '时值日本大正时期。传说太阳下山后，有恶鬼出没吃人。亦有猎鬼人斩杀恶鬼、保护人们。卖炭少年炭治郎，他那平凡而幸福的日常生活，在家人遭到恶鬼袭击的那一天发生了剧变。母亲与四个弟妹惨遭杀害，而与他一起生还的妹妹祢豆子亦异变成凶暴的鬼。',
    tags: ['热血', '战斗', '奇幻', '少年'],
    episodes: [
      { id: 1, title: '第一集 为了打倒鬼舞辻无惨', episode: 1 },
      { id: 2, title: '第二集 水之呼吸的继承者', episode: 2 },
      { id: 3, title: '第三集 柱的觉悟', episode: 3 },
      { id: 4, title: '第四集 柱训练开始', episode: 4 },
      { id: 5, title: '第五集 各自的训练', episode: 5 },
      { id: 6, title: '第六集 柱合会议', episode: 6 },
      { id: 7, title: '第七集 最终选拔', episode: 7 },
      { id: 8, title: '第八集 无限城', episode: 8 },
    ],
    views: 12560000,
    updateTime: '2026-07-28',
  },
  {
    id: 2,
    title: '咒术回战 第二季',
    slug: 'zhoushu-huizhan-s2',
    category: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20poster%20style%2C%20sorcerer%20with%20dark%20energy%20surrounding%2C%20intense%20expression%2C%20dark%20urban%20background%2C%20cinematic%20composition%2C%20clean%20anime%20aesthetic&width=400&height=560&seq=anime-02&orientation=portrait',
    rating: 9.3,
    year: 2023,
    region: '日本',
    status: '已完结',
    description: '少年感到了"死亡"，在一次意外中吞下了被封印的诅咒手指，让他的校园生活发生了翻天覆地的变化。为了解除诅咒，他成为了咒术师，踏上了与诅咒战斗的道路。',
    tags: ['热血', '战斗', '校园', '奇幻'],
    episodes: [
      { id: 9, title: '第一集 怀玉', episode: 1 },
      { id: 10, title: '第二集 怀玉 贰', episode: 2 },
      { id: 11, title: '第三集 玉折', episode: 3 },
    ],
    views: 9800000,
    updateTime: '2026-07-15',
  },
  {
    id: 3,
    title: '凡人修仙传',
    slug: 'fanren-xiuxian-zhuan',
    category: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%2C%20immortal%20cultivator%20in%20flowing%20robes%20with%20spiritual%20energy%2C%20ancient%20Chinese%20mountain%20landscape%2C%20mystical%20atmosphere%2C%20clean%20donghua%20aesthetic&width=400&height=560&seq=anime-03&orientation=portrait',
    rating: 9.1,
    year: 2025,
    region: '中国',
    status: '更新中',
    description: '平凡少年韩立出身贫苦，为了家人前往七玄门参加入门考核，最终被墨大夫收入门下。从此他凭着坚定的意志踏上了修仙之路，在这条充满危险的道路上不断变强。',
    tags: ['修仙', '国漫', '奇幻', '冒险'],
    episodes: [
      { id: 12, title: '第一集 踏上修仙路', episode: 1 },
      { id: 13, title: '第二集 入门考核', episode: 2 },
      { id: 14, title: '第三集 修炼之路', episode: 3 },
      { id: 15, title: '第四集 突破瓶颈', episode: 4 },
      { id: 16, title: '第五集 新的征程', episode: 5 },
    ],
    views: 15600000,
    updateTime: '2026-08-01',
  },
  {
    id: 4,
    title: '葬送的芙莉莲',
    slug: 'zangsong-de-fulilian',
    category: 'jingdian',
    coverImage: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20poster%20style%2C%20elf%20mage%20in%20white%20robes%20walking%20through%20flower%20field%2C%20nostalgic%20atmosphere%2C%20soft%20lighting%2C%20fantasy%20manga%20aesthetic%2C%20clean%20composition&width=400&height=560&seq=anime-04&orientation=portrait',
    rating: 9.8,
    year: 2023,
    region: '日本',
    status: '已完结',
    description: '魔法使芙莉莲与勇者辛美尔等人历经十年的冒险，打倒魔王为世界带来了和平。身为精灵的她，再次与伙伴们重逢时，才发现自己对人类"短命"这件事的悲哀。为了了解人类，她踏上了新的旅程。',
    tags: ['奇幻', '冒险', '治愈', '经典'],
    episodes: [
      { id: 17, title: '第一集 冒险的结束', episode: 1 },
      { id: 18, title: '第二集 新的旅程', episode: 2 },
      { id: 19, title: '第三集 再见故人', episode: 3 },
    ],
    views: 18200000,
    updateTime: '2026-06-20',
  },
  {
    id: 5,
    title: '进击的巨人 最终季',
    slug: 'jinji-de-juren-final',
    category: 'jingdian',
    coverImage: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20anime%20poster%2C%20giant%20titan%20silhouette%20against%20blood%20red%20sky%2C%20soldiers%20with%20maneuver%20gear%2C%20epic%20cinematic%20composition%2C%20dark%20dramatic%20atmosphere&width=400&height=560&seq=anime-05&orientation=portrait',
    rating: 9.4,
    year: 2023,
    region: '日本',
    status: '已完结',
    description: '在艾伦他们居住的帕拉迪岛之外，还存在一个其他人类居住的世界。当中存在着"其他人类"与"艾尔迪亚人"两个种族。艾尔迪亚人过去凭藉着巨人之力成为了世界霸者，让"其他人类"对他们产生恐惧。',
    tags: ['热血', '战斗', '奇幻', '末日'],
    episodes: [
      { id: 20, title: '最终季 第一集', episode: 1 },
      { id: 21, title: '最终季 第二集', episode: 2 },
    ],
    views: 21000000,
    updateTime: '2026-05-10',
  },
  {
    id: 6,
    title: '全职高手 第三季',
    slug: 'quanzhi-gaoshou-s3',
    category: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=The%20Kings%20Avatar%20anime%20poster%2C%20esports%20player%20with%20gaming%20headset%2C%20futuristic%20gaming%20battlefield%20background%2C%20dynamic%20action%2C%20Chinese%20donghua%20style%2C%20clean%20composition&width=400&height=560&seq=anime-06&orientation=portrait',
    rating: 8.9,
    year: 2025,
    region: '中国',
    status: '更新中',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐。离开职业圈的他寄身于一家网吧成了一个小小的网管，但是他拥有十年的游戏经验，带着对往昔的回忆和一把未完成的自制武器，开始了重返巅峰之路。',
    tags: ['游戏', '电竞', '国漫', '热血'],
    episodes: [
      { id: 22, title: '第一集 重返荣耀', episode: 1 },
      { id: 23, title: '第二集 君莫笑', episode: 2 },
      { id: 24, title: '第三集 挑战赛', episode: 3 },
      { id: 25, title: '第四集 全明星赛', episode: 4 },
    ],
    views: 8900000,
    updateTime: '2026-07-30',
  },
  {
    id: 7,
    title: '我推的孩子',
    slug: 'wotui-de-haizi',
    category: 'lianai',
    coverImage: 'https://readdy.ai/api/search-image?query=Oshi%20no%20Ko%20anime%20poster%2C%20idol%20singer%20with%20sparkling%20star%20eyes%20on%20stage%2C%20bright%20stage%20lights%2C%20clean%20colorful%20anime%20aesthetic%2C%20dreamy%20atmosphere&width=400&height=560&seq=anime-07&orientation=portrait',
    rating: 9.0,
    year: 2023,
    region: '日本',
    status: '已完结',
    description: '在乡下工作的妇产科医生五郎，本应该是与演艺圈无缘的人生，但他"推"的偶像星野爱出现在了他面前。他与爱之间发生了许多意想不到的事，命运的齿轮开始转动。',
    tags: ['偶像', '恋爱', '剧情', '悬疑'],
    episodes: [
      { id: 26, title: '第一集 Mother and Children', episode: 1 },
      { id: 27, title: '第二集 第三个选择', episode: 2 },
      { id: 28, title: '第三集 漫画原作', episode: 3 },
    ],
    views: 7600000,
    updateTime: '2026-04-15',
  },
  {
    id: 8,
    title: '完美世界',
    slug: 'wanmei-shijie',
    category: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Perfect%20World%20donghua%20poster%2C%20ancient%20warrior%20with%20glowing%20energy%20in%20mythical%20Chinese%20landscape%2C%20celestial%20beings%2C%20epic%20fantasy%20atmosphere%2C%20clean%20donghua%20aesthetic&width=400&height=560&seq=anime-08&orientation=portrait',
    rating: 8.7,
    year: 2025,
    region: '中国',
    status: '更新中',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。问苍茫大地，谁主沉浮？一个少年从大荒中走出，一切从这里开始。',
    tags: ['玄幻', '修仙', '国漫', '热血'],
    episodes: [
      { id: 29, title: '第一集 大荒少年', episode: 1 },
      { id: 30, title: '第二集 走出大荒', episode: 2 },
      { id: 31, title: '第三集 初入修炼界', episode: 3 },
    ],
    views: 11200000,
    updateTime: '2026-08-02',
  },
  {
    id: 9,
    title: '间谍过家家',
    slug: 'jiandie-guojiajia',
    category: 'rexue',
    coverImage: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20poster%2C%20family%20of%20three%20with%20secret%20identities%2C%20spy%20dad%20assassin%20mom%20and%20telepath%20daughter%2C%20warm%20family%20comedy%20atmosphere%2C%20clean%20anime%20aesthetic&width=400&height=560&seq=anime-09&orientation=portrait',
    rating: 9.2,
    year: 2022,
    region: '日本',
    status: '已完结',
    description: '为了潜入名校，西国能力最强的间谍黄昏被下令组建家庭。但是，他的"女儿"居然是能够读取他人内心的超能力者，"妻子"是暗杀者。三人利害关系一致，便互相隐瞒身份开始了共同生活。',
    tags: ['喜剧', '家庭', '间谍', '温馨'],
    episodes: [
      { id: 32, title: '第一集 任务开始', episode: 1 },
      { id: 33, title: '第二集 找到妻子', episode: 2 },
    ],
    views: 13500000,
    updateTime: '2026-03-28',
  },
  {
    id: 10,
    title: '灵笼',
    slug: 'linglong',
    category: 'kehuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Ling%20Cage%20Incarnation%20donghua%20poster%2C%20post-apocalyptic%20sci-fi%20warrior%20with%20mechanical%20exoskeleton%2C%20dark%20futuristic%20city%2C%20dystopian%20atmosphere%2C%20clean%20Chinese%203D%20animation%20style&width=400&height=560&seq=anime-10&orientation=portrait',
    rating: 8.5,
    year: 2024,
    region: '中国',
    status: '已完结',
    description: '不久的未来，人类的世界早已拥挤不堪。迈向星河、寻找新家园的行动迫在眉睫。正当一切有条不紊的推进之时，月相异动，大地爆发了长达数十年剧烈的地质变化，人类在这场浩劫中所剩无几。',
    tags: ['科幻', '末日', '国漫', '机甲'],
    episodes: [
      { id: 34, title: '第一集 末日降临', episode: 1 },
      { id: 35, title: '第二集 灯塔', episode: 2 },
      { id: 36, title: '第三集 地面', episode: 3 },
    ],
    views: 6700000,
    updateTime: '2026-02-14',
  },
  {
    id: 11,
    title: '链锯人',
    slug: 'lianju-ren',
    category: 'rexue',
    coverImage: 'https://readdy.ai/api/search-image?query=Chainsaw%20Man%20anime%20poster%2C%20chainsaw-headed%20demon%20hunter%20in%20urban%20setting%2C%20blood%20splatter%20dynamic%20action%2C%20dark%20gritty%20atmosphere%2C%20punk%20manga%20aesthetic&width=400&height=560&seq=anime-11&orientation=portrait',
    rating: 8.8,
    year: 2022,
    region: '日本',
    status: '已完结',
    description: '少年淀治为了偿还父亲留下的债务，与恶魔啵奇塔一起过着贫困的生活。在一次意外中被杀后，啵奇塔与他合为一体，让他变成了拥有链锯能力的恶魔猎人。',
    tags: ['热血', '战斗', '黑暗', '恶魔'],
    episodes: [
      { id: 37, title: '第一集 狗与链锯', episode: 1 },
      { id: 38, title: '第二集 东京到达', episode: 2 },
    ],
    views: 9400000,
    updateTime: '2026-01-20',
  },
  {
    id: 12,
    title: '斗罗大陆',
    slug: 'douro-dalu',
    category: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Soul%20Land%20donghua%20poster%2C%20warrior%20with%20glowing%20martial%20spirit%20energy%2C%20ancient%20Chinese%20fantasy%20world%2C%20epic%20adventure%20atmosphere%2C%20clean%203D%20donghua%20aesthetic&width=400&height=560&seq=anime-12&orientation=portrait',
    rating: 8.6,
    year: 2025,
    region: '中国',
    status: '更新中',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。这里没有魔法，没有斗气，没有武术，却有神奇的武魂。',
    tags: ['玄幻', '国漫', '热血', '冒险'],
    episodes: [
      { id: 39, title: '第一集 穿越斗罗', episode: 1 },
      { id: 40, title: '第二集 觉醒武魂', episode: 2 },
      { id: 41, title: '第三集 诺丁学院', episode: 3 },
    ],
    views: 19800000,
    updateTime: '2026-07-31',
  },
];

export const faqData = [
  {
    question: '6080影视需要付费吗？',
    answer: '完全不需要！6080影视承诺永久免费，所有动漫番剧均可免费高清观看，无需任何会员或付费。我们依靠广告收入维持运营，致力于为广大动漫爱好者提供最好的免费追番体验。',
  },
  {
    question: '播放会卡顿缓冲吗？',
    answer: '6080影视采用先进的CDN加速技术和多线服务器部署，确保全国用户都能享受流畅不缓冲的观看体验。我们持续优化播放器性能，即使在高清画质下也能保持丝滑流畅。',
  },
  {
    question: '动漫资源更新频率如何？',
    answer: '我们保持着与日本和国内番剧同步更新的速度。新番一般在播出后2小时内上线，热门番剧更是力争1小时内更新。每周固定更新日，请关注首页更新预告。',
  },
  {
    question: '可以在手机上观看吗？',
    answer: '当然可以！6080影视完美适配手机、平板和电脑端。无论在通勤路上还是在家休闲，随时随地打开浏览器就能追番，无需下载任何APP。',
  },
  {
    question: '如何找到想看的动漫？',
    answer: '您可以通过首页的分类导航、搜索框搜索，或浏览热门推荐来找到心仪的动漫。我们支持按类型、地区、年份等多维度筛选，帮助您快速定位想要的番剧。',
  },
  {
    question: '支持弹幕功能吗？',
    answer: '目前6080影视专注于提供最佳的观看画质和播放体验，弹幕功能正在开发中。您可以通过评论区与其他动漫迷交流讨论，分享追番心得。',
  },
];

export const testimonials = [
  {
    name: '小明的动漫日记',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20cute%20boy%20avatar%20portrait%2C%20simple%20colorful%20background%2C%20clean%20manga%20art%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: '6080影视是我用过最流畅的追番网站！画质清晰还不卡顿，更新速度更是没话说。强烈推荐给所有动漫迷！',
    rating: 5,
  },
  {
    name: '二次元研究所',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20cute%20girl%20avatar%20portrait%2C%20pink%20simple%20background%2C%20clean%20manga%20art%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '资源太全了！从经典老番到最新新番都有，国漫日漫一网打尽。分类也很清楚，找番特别方便。',
    rating: 5,
  },
  {
    name: '追番狂魔小李',
    avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20cool%20boy%20avatar%20portrait%2C%20dark%20simple%20background%2C%20clean%20manga%20art%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '免费高清还不缓冲，简直良心！朋友推荐的，用了一次就回不去了。现在每天都要上来看看有没有更新。',
    rating: 5,
  },
];

export const siteStats = [
  { label: '动漫资源', value: '10000+', icon: 'ri-movie-line' },
  { label: '日活跃用户', value: '50万+', icon: 'ri-user-line' },
  { label: '累计播放', value: '10亿+', icon: 'ri-play-circle-line' },
  { label: '运行天数', value: '1800+', icon: 'ri-calendar-line' },
];